import { useState, useEffect,useRef } from "react";

// @mui material components
import Divider from "@mui/material/Divider";
import Box from '@mui/material/Box'
import List from "@mui/material/List";
import {useMediaQuery} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Draw from '@mui/material/Drawer';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import {Autocomplete} from "@mui/material";
import TextField from "@mui/material/TextField";
import BootstrapInput from "components/MDField";

// @mui icons
import { Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from "@mui/material/styles";
import MDButton from "components/MDButton";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { position } from "stylis";
import { RemoveCircleOutline } from "@mui/icons-material";
import {Dialog,DialogContent,DialogTitle,DialogContentText,DialogActions} from "@mui/material";
import { initializeApp } from 'firebase/app';
import { getDatabase, ref, onValue, query, orderByChild, push, off, onChildAdded, startAt  } from "firebase/database";
import ScreenBlocker from "components/ScreenBlocker";
import { useMaterialUIController } from "context";


function Dialogtransferir(props) {
  const [controller] = useMaterialUIController();
  const { usuarioLog, claveLog } = controller;
  const pantallathme = useTheme()
  const matches = useMediaQuery(pantallathme.breakpoints.up('md'));


  const [mensajeTransferir,setMensajeTransferir] = useState("Enviar Transferencia")//"Enviar Autorizacion")  
  const [autorizacionEnviada,setAutorizacionEnviada] = useState(false)
  const [autorizacionAceptada,setAutorizacionAceptada] = useState(false)
  const [autorizacionDeclinada,setAutorizacionDeclinada] = useState(false)
  const [colorMensajeTransferir,setColorMensajeTransferir] = useState("success")    
  const [autorizacionId,setAutorizacionId] = useState()
  const initialLoad = useRef(true);

  const [transferenciaEnviada,setTransferenciaEnviada] = useState(false)


  const [abrirmensaje,setAbrirmensaje] = useState(false)
  const [titulo,setTitulo] = useState()
  const [mensaje,setMensaje] = useState()


  const [sucursalTrans, setSucursalTrans] = useState('') 
  const [currentsucursal, setCurrentSucursal] = useState(props.current) 
  const [comentario,setComentario] = useState('Comentario')
  const [transportista,setTransportista] = useState('Transportista')
  const [sucursales,setSucursales] = useState(props.sucursales);

  const firebaseConfig = {
    apiKey: "AIzaSyDTz01ErbwTUg7Kjz0ayhMKr8NXgzOOQJs",
    authDomain: "webmotors-e1b4a.firebaseapp.com",
    databaseURL: "https://webmotors-e1b4a-default-rtdb.firebaseio.com",
    projectId: "webmotors-e1b4a",
    storageBucket: "webmotors-e1b4a.appspot.com",
    messagingSenderId: "21788133575",
    appId: "1:21788133575:web:11592e57db8c3bd81396e2",
    measurementId: "G-5J6JYV3TJS"
  };
  
  
  const app = initializeApp(firebaseConfig);
  const database = getDatabase(app);
  var isChanged = false

  const autorizacionEnviadaRef = useRef(autorizacionEnviada); // Track the latest state manually

  useEffect(() => {
    autorizacionEnviadaRef.current = autorizacionEnviada; // keep ref in sync
  }, [autorizacionEnviada]);

  useEffect(() => {
    

    const newItems = sucursales.filter(item => item.label !== currentsucursal);
    setSucursales(newItems);
  
    const now = Date.now(); // Get current time
  
    const dataRef = ref(database,  localStorage.getItem("nombrenegocio").replaceAll(" ",""));

    // Set up active listener
    onChildAdded(dataRef, (snapshot) => {
        const newMessage = snapshot.val();


        if(autorizacionEnviadaRef.current){


          if(newMessage.Modulo == "Autorizaciones" && newMessage.Accion == "Aprobar" && newMessage.Sucursal == currentsucursal && newMessage.Descripcion.includes("Aut.Transf")){
              setColorMensajeTransferir("success")
              setMensajeTransferir("Transferir")  
              setAutorizacionAceptada(true)  
              setAutorizacionEnviada(false)
              setAutorizacionDeclinada(false)
  //            alert("Autorizacion Aceptada ")

          }
          if(newMessage.Modulo == "Autorizaciones" && newMessage.Accion == "Declinar" && newMessage.Sucursal == currentsucursal && newMessage.Descripcion.includes("Aut.Transf")){
    //        alert("Autorizacion Declinada" )
            setColorMensajeTransferir("error")
            setMensajeTransferir("Autorizacion Declinada")  
            setAutorizacionAceptada(false)  
            setAutorizacionEnviada(false)
            setAutorizacionDeclinada(true)
            
            props.transferidos.map((row) => {
              props.eliminarTransferido(row);
            })

          }
        }

      });


      const handleBeforeUnload = (event) => {
        if(autorizacionEnviada){        
    
          var json = {"Descripcion":autorizacionAceptada?"no utilizo la autorizacion":"cancelo la peticion de autorizacion"};
          var modulo = "Autorizaciones"
          var accion = "Cancelar"
    
          const request = {
            method: 'POST',
            headers: {'Content-Type':'application/json'},
            body: JSON.stringify({"randomid":autorizacionId,'password':claveLog,usuario:usuarioLog}) 
          }
          fetch(process.env.REACT_APP_SERVIDOR+'/api/cancelarautorizacion',request)
          .then(function(response){
            if (response.status === 200) {
              response.json().then(function(data){
                    
                const dbRef = ref(database, localStorage.getItem("nombrenegocio").replaceAll(" ","")); // Specify the path in the database
                const date = new Date();
                const day = date.getUTCDate(); // Day of the month
                const month = date.getUTCMonth() + 1; // Months are zero-based, so add 1
                const year = date.getUTCFullYear(); // Full year
                const fechadesde = `${year}-${month}-${day}`;
            
                push(dbRef, {
                    "Accion":accion,
                    "Descripcion":JSON.stringify(json),
                    "Modulo":modulo,
                    "Fecha": fechadesde,
                    "Hora": Date.now().toString(),
                    "Sucursal":currentsucursal,
                    "Usuario":localStorage.getItem("usuario"),
            
                })
                .then(() => {
                    console.log("Data pushed successfully!");
                })
                .catch((error) => {console.error("Error pushing data: ", error);});
    
              })
    
          
            
            }
            if (response.status === 400) {
              alert(response.statusText)
                response.json().then(function(data){
                  alert(data["Error"])            
                })
            }
          })
          setAutorizacionEnviada(true)
        }  
    
    
        event.preventDefault();
        event.returnValue = ''; // Modern browsers require returnValue to be set
      };

      const handleUnload = () => {
        // Handle logic when page reloads or closes
        console.log("Page is unloading");
      };

//      window.addEventListener('beforeunload', handleBeforeUnload);
  //    window.addEventListener('unload', handleUnload);
      // Clean up listener on component unmount
//      return () => off(dataRef, 'value', listener);    
  //    return () => unsubscribe();
  

  },[]);


  const DemoPaper = styled(Paper)(({ pantallathme }) => ({
    marginLeft:10,
    marginTop:10,
    width: 280,
    height: 70,
    backgroundColor:"#c5dafc",
    padding: 0,
    textAlign: 'center',
  }));
  


  const drawerOpenStyles = () => ({
    width: matches ? 250 : 300,
    left: "initial",
    right: 0,
  });


  function createTransaction(){
    if(sucursalTrans==''){
      return;
    }

    setAbrirmensaje(true)
  }

  function sendAuthorization(){


    if(sucursalTrans==''){
      return;
    }


    if(!autorizacionEnviada){
      setColorMensajeTransferir("warning")
      setMensajeTransferir("Esperando Autorizacion...")
      

      var json = {"Descripcion":"solicito realizar una transferencia hacia "+sucursalTrans.split("-")[1],"tipo":"Aut.Transf","motores":JSON.stringify(props.transferidos)};

      const request = {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({'sucdesde': currentsucursal,"suchacia":sucursalTrans,"motores":props.transferidos,"randomid":"",
          'password':claveLog,usuario:usuarioLog}) 
      }
      fetch(process.env.REACT_APP_SERVIDOR+'/api/crearautorizacion',request)
      .then(function(response){
        if (response.status === 200) {
          response.json().then(function(data){
            isChanged = true
            setAutorizacionEnviada(true)    
            setAutorizacionId(data["id"])
            const dbRef = ref(database, localStorage.getItem("nombrenegocio").replaceAll(" ","")); // Specify the path in the database
            const date = new Date();
            const day = date.getUTCDate(); // Day of the month
            const month = date.getUTCMonth() + 1; // Months are zero-based, so add 1
            const year = date.getUTCFullYear(); // Full year
            const fechadesde = `${year}-${month}-${day}`;
        
            push(dbRef, {
                "Accion":"Solicitar",
                "Descripcion":JSON.stringify(json),
                "Modulo":"Autorizaciones",
                "Fecha": fechadesde,
                "Hora": Date.now().toString(),
                "Sucursal":currentsucursal,
                "Usuario":localStorage.getItem("usuario"),      
            })
            .then(() => {
                console.log("Data pushed successfully!");
            })
            .catch((error) => {console.error("Error pushing data: ", error);});

          })

      
        
        }
        if (response.status === 400) {
          alert(response.statusText)
            response.json().then(function(data){
              alert(data["Error"])            
            })
        }
      })
    }  



  }
  
  function DialogConfirm(props) {
    
    return (
        <Dialog
          open={props.open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          sx = {{
            '& .MuiDialog-paper':{borderRadius:"15px"}
          }}
        >
          <DialogTitle style={{fontWeight:"bold"}}>
            Realizar Transferencia
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description" >
                Autorizar transferencia desde <strong>{currentsucursal.split("-")[1]}</strong> hacia <strong>{sucursalTrans.split("-")[1]}</strong>
            </DialogContentText>
          </DialogContent>
          <Box style={{display: "flex", justifyContent: "center",marginTop:"-15px"}}>
          <DialogActions>
          <MDButton variant="gradient" color="warning" style={{width:"150px",marginTop:"15px"}} onClick={()=>{setAbrirmensaje(false)}}>
              No
            </MDButton>

            <MDButton variant="gradient" color="success" style={{width:"150px",marginTop:"15px", fontWeight:"bold"}} onClick={()=>
              {if(!transferenciaEnviada){props.confirmar(sucursalTrans,transportista,comentario,props.setOpen,props.setOpenpantallatransferencia)}setTransferenciaEnviada(true)}}>
              si
            </MDButton>
          </DialogActions>
          </Box>
        </Dialog>
    );
  }


  return (
    <Draw
      sx={{
      '& .MuiDrawer-paper': {
       height: "100vh",
       margin: 0,
       padding: `1opx`,
       borderRadius: 0,
       boxShadow: 5,
       overflowY: "auto",
       ...(drawerOpenStyles())},
      }}
      variant = 'persistent'
      open = {props.openpantallatransferencia}
    >
      
      <DialogConfirm open={abrirmensaje} confirmar={props.confirmar} setOpen={setAbrirmensaje} setOpenpantallatransferencia={props.setOpenpantallatransferencia}></DialogConfirm>
      <ScreenBlocker show={autorizacionEnviada} message="Esperando aprobacion, por favor espere..." />  


    <Box style={{margin:"2%"}}>
      <Grid
        direction="row"
        container
        justifyContent={"center"}
        textAlign={"center"}>
        



        <Box marginTop={5}>       
          <h2>Transferir</h2>
          <Autocomplete
            style={{marginTop:"15px"}}
                    variant = "standard"    
                    disablePortal
                    id="combo-box-demo"
                    options={sucursales}
                    value = {sucursalTrans}
                    onBlur={(event) => setSucursalTrans(event.target.value)}
                    sx = {{ disableUnderline: true}}
                    
                                      
                    renderInput={(params) => 
                    <TextField {...params} 
                      variant = "standard"
                      label="Buscar sucursal:" 
                      sx={{boxShadow: 4, borderRadius: 2,width:"200px" ,height:"55px",backgroundColor: "white"}}
                      InputLabelProps={{
                        shrink: "true",
                        style:{
                          paddingLeft: "10px",
                          paddingTop: "5px",
                          disableUnderline: true,
                        }
                      }}
                      InputProps={{
                        ...params.InputProps,disableUnderline:true,borderRadius:5,
                        style:{
                          fontSize: "14px",
                          marginLeft: "5px",
                          marginTop: "20px",  
                        }}}
           />}
          />

         </Box>

         
      </Grid>
      <Divider />
     
      <Grid container style={{marginTop:"15px"}} spacing={2}>
      <TableContainer component={Paper} style={{maxHeight:350,overflowX:"hidden"}}>
      <Table sx={{ width: 40,marginLeft:2,marginRight:2 }}  aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Chasis</TableCell>
          </TableRow>
        </TableHead>
        <TableBody  >
          {props.transferidos.map((row) => (
            <TableRow
              key={row.chasis}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell align="left">{row.Chasis}</TableCell>
              <RemoveCircleOutline style={{color:"red",height:30,width:30,marginTop:9}} onClick={()=>{props.eliminarTransferido(row);
                if(props.transferidos.length==0){
                  setAutorizacionDeclinada(false)
                  setAutorizacionAceptada(false)
                  setAutorizacionAceptada(false)
                }
              }}></RemoveCircleOutline>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>

      
       </Grid>
       <Box sx={{flexDirection:"column",display:"flex"}} style={{left: 0, right: 0, bottom: 0,justifyContent: 'center', alignItems: 'center',position:"absolute"}}>
          <BootstrapInput value={transportista} onChange={(event)=>{setTransportista(event.target.value)}}  id="bootstrap-input" sx={{left: 0, right: 0,}} fullWidth />

          <BootstrapInput value={comentario} onChange={(event)=>{setComentario(event.target.value)}}  id="bootstrap-input" sx={{left: 0, right: 0,}} fullWidth />
          <Box marginTop={1}></Box>
          <MDButton variant="gradient" color={"success"} onClick={()=>{createTransaction()}} fullWidth>Transferir</MDButton>
       </Box>
    </Box>
    </Draw>
  );
}

export default Dialogtransferir;
